module.exports = Studio.libraries['superagent'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['superagent']"
 ** module id = 5
 ** module chunks = 0
 **/